











import { Component, Mixins, Prop } from "vue-property-decorator";
import { SingleSelectableMixin } from "./mixins";

@Component({
})
export default class RadioButtonSelector extends Mixins(SingleSelectableMixin) {
  @Prop({ default: "standard" })
  type: string;

  @Prop({ default: true })
  isEnable: boolean;

  @Prop()
  isDeselectable: boolean;

  @Prop()
  isOptionEnable: (d: any) => boolean;

  @Prop()
  isNotOption: (d: any) => boolean;

  toItemClass(value: any): string {
    return this.type
      + ((this.selectedOption === value) ? " selected" : (this.isItemEnable(value) ? "" : " disabled"));
  }

  isItemEnable(value: any): boolean {
    return this.isEnable
        && (!this.isOptionEnable || this.isOptionEnable(value));
  }

  isItemNotOption(value: any): boolean {
    return this.isNotOption && this.isNotOption(value);
  }

  selectItem(value: any): void {
    if (!this.isItemEnable(value)) {
      return;
    }
    if (this.selectedOption === value) {
      if (this.isDeselectable) {
        this.selectedOption = null;
      }
    } else {
      this.selectedOption = value;
    }
  }
}
